import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/da2ltuaamq5jpe1hs090";

type Status = "idle" | "success" | "error";

export default function Newsletter() {
  const [status, setStatus] = useState<Status>("idle");
  const [formError, setFormError] = useState("");

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = ((fd.get("website_alt") as string) || "").trim();
    if (honeypot) {
      setStatus("success");
      form.reset();
      return;
    }
    fd.delete("website_alt");

    setStatus("idle");
    setFormError("");

    try {
      const params = new URLSearchParams();
      fd.forEach((value, key) => params.append(key, String(value)));

      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const message =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
      const code = parsed?.code;

      if (res.ok && code === "OK") {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
        setFormError(typeof message === "string" ? message : "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setFormError("网络异常，请稍后重试。");
    }
  }

  return (
    <section
      id="subscribe"
      className="relative overflow-hidden py-16 md:py-24"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Ancient%20chinese%20fantasy%20scroll%20and%20ink%20brush%20motif%20with%20golden%20clouds%20and%20floating%20calligraphy%20particles%20over%20a%20deep%20warm%20crimson%20background%2C%20elegant%20minimal%20ink%20wash%20style%2C%20high%20detail&width=1600&height=640&seq=newsletter-bg&orientation=landscape"
          alt="追更提醒订阅背景"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-foreground-950/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-3xl px-4 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-400/40 bg-accent-500/10 px-4 py-1.5 text-xs font-medium text-accent-200">
          <i className="ri-mail-send-line" /> 追更提醒订阅
        </span>
        <h2 className="mt-5 font-heading text-2xl font-bold text-background-50 md:text-3xl">
          剧情更新，第一时间知道
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-background-100/85 md:text-base">
          留下邮箱，当主篇后续剧情或本站追更整理更新时，我们会发邮件提醒你，追更不迷路。
        </p>

        <form
          id="subscribe-form"
          data-readdy-form="追更提醒订阅"
          onSubmit={handleSubmit}
          className="mx-auto mt-8 max-w-xl"
        >
          <div className="flex flex-col gap-3 sm:flex-row">
            <label htmlFor="subscribe-email" className="sr-only">
              邮箱地址
            </label>
            <input
              id="subscribe-email"
              name="email"
              type="email"
              required
              autoComplete="email"
              placeholder="请输入你的邮箱"
              className="h-12 flex-1 rounded-md border border-background-50/20 bg-background-50/95 px-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-accent-400 focus:outline-none focus:ring-2 focus:ring-accent-400/40"
            />
            <button
              type="submit"
              className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              订阅追更提醒
              <i className="ri-arrow-right-line" />
            </button>
          </div>
          <input
            name="website_alt"
            type="text"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="affiliate-optin"
          />
        </form>

        {status === "success" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-accent-500/15 px-4 py-2 text-sm text-accent-200">
            <i className="ri-checkbox-circle-line" /> 订阅成功，感谢关注！
          </p>
        )}
        {status === "error" && (
          <p className="mt-4 inline-flex items-center gap-2 rounded-md bg-primary-500/20 px-4 py-2 text-sm text-background-100">
            <i className="ri-error-warning-line" /> {formError}
          </p>
        )}
      </div>
    </section>
  );
}